import { OCCURRED_AT_MAX_DAYS_BACK } from '@performance-crm/shared';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toLocalInput } from '@/lib/format';

const DAY_MS = 86_400_000;

/**
 * «¿Cuándo ocurrió?»: fecha y hora en que se hizo la gestión o la visita (Lote 2 · E3). Por defecto ahora; admite
 * fechas pasadas hasta `OCCURRED_AT_MAX_DAYS_BACK` días atrás y nunca futuras (la API valida lo mismo). Es un campo
 * suelto para que cualquier diálogo (registrar gestión, completar tarea, proforma con visita) lo incluya sin más;
 * los helpers `occurredAtNow` / `occurredAtToDate` viven en `occurredAt.ts`.
 */
export function OccurredAtField({
  value,
  onChange,
  id = 'occurred-at',
  label = '¿Cuándo ocurrió?',
  hint,
  className,
  tz,
}: {
  value: string;
  onChange: (v: string) => void;
  id?: string;
  label?: string;
  /** Texto de ayuda; por defecto explica la ventana permitida. */
  hint?: string | null;
  className?: string;
  /** Zona de la empresa para los topes del campo (Lima por defecto). */
  tz?: string;
}) {
  const now = new Date();
  const min = toLocalInput(new Date(now.getTime() - OCCURRED_AT_MAX_DAYS_BACK * DAY_MS), tz);
  const max = toLocalInput(now, tz);
  return (
    <div className={`space-y-1 ${className ?? ''}`}>
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        type="datetime-local"
        value={value}
        min={min}
        max={max}
        onChange={(e) => onChange(e.target.value)}
        required
        data-testid={id}
      />
      {hint !== null && (
        <p className="text-muted-foreground text-xs">
          {hint ??
            `Por defecto, ahora. Si fue antes, pon la fecha y hora reales (hasta ${OCCURRED_AT_MAX_DAYS_BACK} días atrás, nunca a futuro).`}
        </p>
      )}
    </div>
  );
}
